function toFeet(n) {
    return Math.floor(n / 12) + "'" + (n % 12) + '"';
}



function getStandarDimensionsFilter(){
	
	var id_surfboardmodel = getQueryString('id_surfboardmodel');
	var length_complete = getQueryString('length_complete');
	
	$('.sblf_filtercheck[name=id_surfboardmodel]').each(function(){
		var t = $(this);
		var val = t.val();
		
		if(val==id_surfboardmodel){
			t.prop('checked', true);
		}
	});

    // it´ already done elsewhere..
    /*
	$('.filterrange_6').slider({
		range: true,
		values: [length_complete, length_complete]
	});

	$('.filterrange_6').closest('label').find('.fr_display').val(toFeet(length_complete)+' Ft');
     */
	
	filterShopBoards();
	
}


// PBS slider change update
// 26.06.2016: added value_min and value_max to use in case o model and length being passed via GET
function startBoardSizeSlider(element, rangeMin, rangeMax, value_min, value_max){

    //console.log( element, rangeMin, rangeMax, value_min, value_max );

    if( value_min == undefined ) value_min = rangeMin;
    if( value_max == undefined ) value_max = rangeMax;

    var slider = $('.'+element+'');
    var isBoardSize = slider.hasClass('filterrange_6');
    var isBoardVolume = slider.hasClass('filterrange_7');
    var isBoardPrice = slider.hasClass('filterrange_11');

    //return;

    slider.slider({
        range: true,
        min: rangeMin,
        max: rangeMax,
        values: [value_min, value_max],
        slide: function(event, ui) {

            //$(this).closest('label').find('.frp_col1 input').val(ui.values[0]);
            //$(this).closest('label').find('.frp_col3 input').val(ui.values[1]);

            //filterShopBoards();

        },

        change: function(ev, ui){

        }

    });

    slider.closest('label').find('.frp_col1 input').val(slider.slider('values', 0));
    slider.closest('label').find('.frp_col3 input').val(slider.slider('values', 1));

    if(isBoardSize){

        window.rangeMin = rangeMin;
        window.rangeMax = rangeMax;

        slider.slider({

            slide: function(event, ui) {

                //if( event != undefined ){

                var minFeetVal = toFeet(ui.values[0]);
                var maxFeetVal = toFeet(ui.values[1]);
                $(this).closest('label').find('.frp_col1 input').val(ui.values[0]);
                $(this).closest('label').find('.frp_col3 input').val(ui.values[1]);

                $(this).closest('label').find('.frp_col1 .fr_display').val(minFeetVal+' Ft');
                $(this).closest('label').find('.frp_col3 .fr_display').val(maxFeetVal+' Ft');

                //}

                console.log('sliding..');

                // where are the values stored?
                filterShopBoards();
            },

            change: function(ev, ui){

                //console.log('change event');
                //console.log(ev, ui);

            },

            stop: function(event, ui){


                // PBS: applying filters only on stop..
                filterShopBoards();

            }

        });

        var minVal = toFeet(slider.closest('label').find('.frp_col1 input').val());
        var maxVal = toFeet(slider.closest('label').find('.frp_col3 input').val());
        slider.closest('label').find('.frp_col1 .fr_display').val(minVal+' Ft')
        slider.closest('label').find('.frp_col3 .fr_display').val(maxVal+' Ft')

        /*
         slider.slider('values', 50, 50);
         slider.slider('values', 50, 50);
         slider.slider('option', 'slide').call($slider);
         */
        //$(".filterrange_6").slider('values', new_length, new_length);

        //$(".filterrange_6").slider('values',0,50); // sets first handle (index 0) to 50
        //$(".filterrange_6").slider('values',1,80);
        //$(".filterrange_6").slider('refresh');



    }




    if(isBoardVolume){
        slider.slider({
            slide: function(event, ui) {
                var minFeetVal = ui.values[0];
                var maxFeetVal = ui.values[1];
                $(this).closest('label').find('.frp_col1 input').val(ui.values[0]);
                $(this).closest('label').find('.frp_col3 input').val(ui.values[1]);

                $(this).closest('label').find('.frp_col1 .fr_display').val(minFeetVal+' Lt');
                $(this).closest('label').find('.frp_col3 .fr_display').val(maxFeetVal+' Lt');

                filterShopBoards();
            }
        });

        var minVal = slider.closest('label').find('.frp_col1 input').val();
        var maxVal = slider.closest('label').find('.frp_col3 input').val();
        slider.closest('label').find('.frp_col1 .fr_display').val(minVal+' Lt')
        slider.closest('label').find('.frp_col3 .fr_display').val(maxVal+' Lt')
    }


    if(isBoardPrice){
        slider.slider({
            slide: function(event, ui) {
                var minPriceVal = ui.values[0];
                var maxPriceVal = ui.values[1];
                //$(this).closest('label').find('.frp_col1 input').val(ui.values[0]);
                //$(this).closest('label').find('.frp_col3 input').val(ui.values[1]);

                $(this).closest('label').find('.frp_col1 .fr_display').val('$ '+minPriceVal+' USD');
                $(this).closest('label').find('.frp_col3 .fr_display').val('$ '+maxPriceVal+' USD');
                
                
            },
            change: function(ev, ui){

                console.log('change event');
                var minPriceVal = ui.values[0];
                var maxPriceVal = ui.values[1];
                $(this).closest('label').find('.frp_col1 input').val(ui.values[0]);
                $(this).closest('label').find('.frp_col3 input').val(ui.values[1]);
                $(this).closest('label').find('.frp_col1 .fr_display').val('$ '+minPriceVal+' USD');
                $(this).closest('label').find('.frp_col3 .fr_display').val('$ '+maxPriceVal+' USD');
                filterShopBoards();

            }
        });

        var minVal = slider.closest('label').find('.frp_col1 input').val();
        var maxVal = slider.closest('label').find('.frp_col3 input').val();
        slider.closest('label').find('.frp_col1 .fr_display').val('$ '+minVal+' USD')
        slider.closest('label').find('.frp_col3 .fr_display').val('$ '+maxVal+' USD')
    }


}




function startBoardSizeSlider_OLD(element, rangeMin, rangeMax){

    console.log( element, rangeMin, rangeMax );

	var slider = $('.'+element+'');
	var isBoardSize = slider.hasClass('filterrange_6');
	var isBoardVolume = slider.hasClass('filterrange_7');
	
	slider.slider({
		range: true,
		min: rangeMin,
		max: rangeMax,
		values: [rangeMin, rangeMax],
		slide: function(event, ui) {
			$(this).closest('label').find('.frp_col1 input').val(ui.values[0]);
			$(this).closest('label').find('.frp_col3 input').val(ui.values[1]);
			filterShopBoards();
		}
	});

	slider.closest('label').find('.frp_col1 input').val(slider.slider('values', 0));
	slider.closest('label').find('.frp_col3 input').val(slider.slider('values', 1));
	
    /*
	if(isBoardSize){
		slider.slider({
			slide: function(event, ui) {
				var minFeetVal = toFeet(ui.values[0]);
				var maxFeetVal = toFeet(ui.values[1]);
				$(this).closest('label').find('.frp_col1 input').val(ui.values[0]);
				$(this).closest('label').find('.frp_col3 input').val(ui.values[1]);
				
				$(this).closest('label').find('.frp_col1 .fr_display').val(minFeetVal+' Ft');
				$(this).closest('label').find('.frp_col3 .fr_display').val(maxFeetVal+' Ft');
                //$('.fr_display_min').val(minFeetVal+' Ft');
                //$('.fr_display_max').val(maxFeetVal+' Ft');
				
				filterShopBoards();
			}
		});
		
		var minVal = toFeet(slider.closest('label').find('.frp_col1 input').val()); 
		var maxVal = toFeet(slider.closest('label').find('.frp_col3 input').val()); 
		slider.closest('label').find('.frp_col1 .fr_display').val(minVal+' Ft')
		slider.closest('label').find('.frp_col3 .fr_display').val(maxVal+' Ft')

	}
     */
	
			
			
	//if(isBoardVolume){
		slider.slider({
			slide: function(event, ui) {

                console.log('sliding: '+isBoardSize);

				var minVal = ui.values[0];
				var maxVal = ui.values[1];
				$(this).closest('label').find('.frp_col1 input').val(ui.values[0]);
				$(this).closest('label').find('.frp_col3 input').val(ui.values[1]);
				
				//$(this).closest('label').find('.frp_col1 .fr_display').val(minFeetVal+' Lt');
				//$(this).closest('label').find('.frp_col3 .fr_display').val(maxFeetVal+' Lt');

                if(isBoardSize){

                    //console.log('is board size');

                    slider.closest('label').find('.frp_col1 .fr_display').val( toFeet( minVal )+' Ft');
                    slider.closest('label').find('.frp_col3 .fr_display').val( toFeet( maxVal )+' Ft');
                    //$('.fr_display_max').val( toFeet( maxVal )+' Ft');

                }else if( isBoardVolume ){

                    slider.closest('label').find('.frp_col1 .fr_display').val(minVal+' Lt')
                    slider.closest('label').find('.frp_col3 .fr_display').val(maxVal+' Lt')

                }

				//filterShopBoards();
			},

            stop: function(event, ui){


                // PBS: applying filters only on stop..
                filterShopBoards();

            }
		});

        // when loaded

		var minVal = slider.closest('label').find('.frp_col1 input').val(); 
		var maxVal = slider.closest('label').find('.frp_col3 input').val();

        if(isBoardSize){

            slider.closest('label').find('.frp_col1 .fr_display').val( toFeet( minVal )+' Ft')
            slider.closest('label').find('.frp_col3 .fr_display').val( toFeet( maxVal )+' Ft')

        }else if( isBoardVolume ){

            slider.closest('label').find('.frp_col1 .fr_display').val(minVal+' Lt')
            slider.closest('label').find('.frp_col3 .fr_display').val(maxVal+' Lt')

        }

	//}
	
	
}

// listen to size.. later..
$('#fr-max-display-6').on('change', function(){

    console.log('mudasti');

})



function clearAllFilters(){
	$(document).on('click', '.btn_clearallfilters', function(e){
		e.preventDefault();
		$('.sblf_filtercheck').prop('checked', false);

		$('.filterrange').each(function(){
			var t = $(this);
			var rangeMin = Number(t.attr('data-min'));
			var rangeMax = Number(t.attr('data-max'));
			t.slider({
				values: [rangeMin, rangeMax]
			});
			t.closest('label').find('.filterrange_preview .fr_min').val(rangeMin);
			t.closest('label').find('.filterrange_preview .fr_max').val(rangeMax);
		});
		
		$('.sblf_filtercheck:first').trigger('change');
	});
}





// this is used for all shop sections..
function filterShopBoards(){
	var qString = '';
	$('.slf_filterlist .slfg_items_inner').each(function(){
		var t = $(this);
		var filterType = t.attr('data-filtertype');
		var filterName = t.attr('data-filterdataname');
		filterName = filterName.split(',');
		var filterNameSize = filterName.length;
		var currFilterString = '';

		if(filterType=='list') {
			t.find('.filterdata:checked').each(function(){
				var tfd = $(this);
				var value = tfd.val();
				currFilterString += value+',';
			});
		} else if(filterType=='range'){
			t.find('.filterdata').each(function(){
				var tfd = $(this);
				var value = tfd.val();
				currFilterString += value+',';
			});
		}
		currFilterString = currFilterString.slice(0,-1);

		if(filterNameSize==1){
			var grpQuery = filterName+'='+currFilterString;
		} else if(filterNameSize==2){
			currFilterString = currFilterString.split(',')
			var grpQuery = filterName[0]+'='+currFilterString[0]+'&'+filterName[1]+'='+currFilterString[1];
		}
		qString += grpQuery+'&';
	});
	qString = qString.slice(0,-1);



	var shop = $('.shoplist').attr('data-shop');

    //console.log( shop );

	if( shop=='boards' ) {
		
        service_productBoardsList(qString);

    }else{

        products_list( shop, qString );

    }
    /*
	} else if(shop=='apparel'){
        //alert('apparel');
		service_productApparelList(qString);
        //service_productAccessoriesList(qString);
	} else if(shop=='accessories'){
		//service_productAccessoriesList(qString);
        products_list( shop );
	}
	*/
}

function filterBoardsInit(){
	$(document).on('change', '.sblf_filtercheck', function(){
		filterShopBoards();
	});
}


$(function(){
	clearAllFilters();
	filterBoardsInit();
});



/*

mover o filtro conforme o ecra vai descendo

function setFilterTop(){
	var t = $(window);
	var checkoutTopExist = $('.shoplist').size();
	if(checkoutTopExist>0){
		var checkOutHeight = $('.shoplist').height();
		var checkOutTop = $('.shoplist').offset().top;
		var checkOutBottom = checkOutTop+checkOutHeight;
		var orderSummaryHeight = $('.shoplist #shop-products-filter').height();
		var scrollTop = t.scrollTop();
		var bottomLimitOfset = 140;
		var bottomLimit = (checkOutBottom-orderSummaryHeight)-bottomLimitOfset;
		function moveOrderSum(pos){
			$('.shoplist #shop-products-filter').stop().animate({
				'top': pos
			});
		}
		if(scrollTop>checkOutTop && scrollTop<bottomLimit){
			moveOrderSum((scrollTop-checkOutTop)+40);
		} else if(scrollTop<checkOutTop){
			moveOrderSum(0);
		} else if(scrollTop>bottomLimit){
			moveOrderSum((((checkOutBottom-checkOutTop)-orderSummaryHeight))-bottomLimitOfset);
		}
	}	
}
$(function(){
	$(window).on('scroll', function(){setFilterTop()});
	$(window).on('resize', function(){setFilterTop()});
});

*/

